import { useState } from "react";

import { Modal } from "@/components/ui";

const COMMON = ["Price too high", "Lost to competitor", "Lead time too long", "Specs not met", "No budget", "No response"];

export function LostReasonDialog({ dealName, onConfirm, onCancel }: { dealName: string; onConfirm: (reason: string) => void; onCancel: () => void }) {
  const [reason, setReason] = useState("");
  return (
    <Modal title={`Mark “${dealName}” as lost`} onClose={onCancel}>
      <form className="space-y-4" onSubmit={(e) => { e.preventDefault(); if (reason.trim()) onConfirm(reason.trim()); }}>
        <div className="flex flex-wrap gap-2">
          {COMMON.map((r) => (
            <button key={r} type="button" onClick={() => setReason(r)}
              className={`rounded-full border px-3 py-1 text-xs ${reason === r ? "border-brand bg-brand-soft text-brand" : "border-line hover:bg-canvas"}`}>{r}</button>
          ))}
        </div>
        <div>
          <label htmlFor="lost-reason" className="label">Reason</label>
          <input id="lost-reason" className="input" value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Why was this deal lost?" autoFocus />
        </div>
        <div className="flex justify-end gap-2">
          <button type="button" className="btn-ghost" onClick={onCancel}>Cancel</button>
          <button type="submit" className="btn-danger" disabled={!reason.trim()}>Mark as lost</button>
        </div>
      </form>
    </Modal>
  );
}
